module.exports = __webpack_public_path__ + "img/star3.f29dce65.svg";